<template>
<v-app>
  <div>
    <v-btn color="info" v-on:click="gotoUsers">Usuarios</v-btn>
    <v-btn color="info" v-on:click="gotoNews">Noticias</v-btn>
    <v-btn color="info" v-on:click="gotoComments">Sugerencias</v-btn>
    <v-btn color="info" v-on:click="gotoShops">Locales</v-btn>
    <v-btn color="error" v-on:click="logout">Salir</v-btn>
    <img src="../assets/logo.png" width="100px" style="float: right;">
    <hr style="margin-bottom: 50px;">

    <div class="display-2" style="margin-bottom: 10px;">
        Sugerencias
    </div>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-form id="theForm" @submit.prevent="answerComment(response)">
            <div v-if="isEdition">
                <h2>Responder Comentario</h2>
                <b>Usuario:</b> {{ author_email }}<br />
                <b>Fecha:</b> {{ createdAtStr }}<br />
                <b>Comentario:</b> {{ comment }}<br />
                <br />

                <v-flex>
                    <v-textarea
                        box
                        label="Respuesta"
                        v-model="response"
                        required
                    ></v-textarea>
                </v-flex>
            </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="button" color="error" @click="clearForm()" style="margin-top: 15px;">Cerrar</v-btn>
          <v-btn type="submit" color="primary" form="theForm" style="margin-top: 15px;">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <table width="100%" style="margin-top: 50px;">
        <thead class="title">
            <th style="text-align: left;">Usuario</th>
            <th style="text-align: left;">Creación</th>
            <th style="text-align: left;">Estado</th>
            <th style="text-align: right;">Acciones</th>
        </thead>
        <tr v-for="(comment, idx) in comments" :key="idx">
            <td style="text-align: left;">{{ comment.author_email }}</td>
            <td style="text-align: left;">{{ comment.createdAtStr }}</td>
            <td style="text-align: left;">{{ comment.response ? 'Respondida' : 'Pendiente' }}</td>
            <td style="text-align: right;">
                <v-btn fab small color="primary" @click="startItemEdit(comment.id)">
                    <v-icon>edit</v-icon>
                </v-btn>
                <v-btn fab small color="error" @click="deleteComment(comment.id)">
                    <v-icon>delete</v-icon>
                </v-btn>
            </td>
        </tr>
        <tr>
            <td style="text-align: left;"></td>
            <td style="text-align: right;" colspan="3">
                <v-btn color="success" @click="getComments()">
                    Cargar mas items
                    <v-icon right>cloud_download</v-icon>
                </v-btn>
            </td>
        </tr>
    </table>
  </div>
</v-app>
</template>

<script>
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import firebase from 'firebase'
import { db } from '../main'

export default {
    name: 'Comments',
    data () {
        return {
            dialog: false,
            comments: [],
            isEdition: false,
            itemID: '',
            author_email: '',
            comment: '',
            createdAtStr: '',
            response: '',
            lastListDoc: null,
            loaderPrefs: {
                'container': null,
                'canCancel': false,
                'color': '#0000FF',
                'background-color': '#FFCC99',
            },
        }
    },
    methods: {
        getComments (auto) {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;
            var query;

            if (vm.lastListDoc) {
                console.log("lastListDoc", vm.lastListDoc);
                query = db.collection("comments")
                    .orderBy("date", "desc")
                    .startAfter(vm.lastListDoc)
                    .limit(10);
            } else {
                console.log("No lastListDoc");
                query = db.collection("comments")
                    .orderBy("date", "desc")
                    .limit(10);
            }

            query.get()
                .then(function(res) {
                    console.log("Received: " + res.docs.length);

                    res.forEach(doc => {
                        let item = doc.data();
                        item.id = doc.id;
                        item.createdAtStr = vm.formatDate(item.date.toDate());
                        vm.comments.push(item);

                        vm.lastListDoc = doc;
                    });

                    if (res.docs.length == 0 && auto !== true) {
                        alert("No hay más sugerencias!");
                    }

                    loader.hide();
            })
            .catch(function(error) {
                console.error("Error getting article list: ", error);
                loader.hide();
            });
        },
        answerComment (response) {
            let loader = this.$loading.show(this.loaderPrefs);
            var vm = this;

            let item = {
                'response': response,
            }

            item.res_date = new Date();
            var itemRef = db.collection("comments").doc(this.itemID);

            itemRef
                .update(item)
                .then(function() {
                    console.log("Document successfully updated!");
                    
                    var idx = -1;
                    for (var i=0; i<vm.comments.length; i++) {
                        if (vm.itemID == vm.comments[i].id) {
                            idx = i;
                            break;
                        }
                    }
                    console.log("idx", idx);

                    if (idx > -1) {
                        vm.comments[idx].response = item.response;
                        vm.comments[idx].res_date = item.res_date;
                    }
                    
                    vm.clearForm();
                    loader.hide();
                })
                .catch(function(error) {
                    console.error("Error updating document: ", error);
                    loader.hide();
                });
        },
        deleteComment (id) {
            if (confirm("Eliminar la sugerencia?")) {
                let loader = this.$loading.show(this.loaderPrefs);
                var vm = this;

                db.collection('comments').doc(id)
                    .delete()
                    .then(function() {
                        var idx = -1;
                        for (var i=0; i<vm.comments.length; i++) {
                            if (id == vm.comments[i].id) {
                                idx = i;
                                break;
                            }
                        }

                        if (idx > -1) {
                            vm.comments.splice(i, 1);
                        }

                        loader.hide();
                    })
                    .catch(function(error) {
                        console.error("Error updating document: ", error);
                        loader.hide();
                    });
            }
        },
        startItemEdit (id) {
            var vm = this;

            var idx = -1;
            for (var i=0; i<vm.comments.length; i++) {
                if (id == vm.comments[i].id) {
                    idx = i;
                    break;
                }
            }

            if (idx > -1) {
                this.isEdition = true;
                this.itemID = vm.comments[idx].id;
                this.author_email = vm.comments[idx].author_email;
                this.comment = vm.comments[idx].comment;
                this.createdAtStr = vm.comments[idx].createdAtStr;
                this.response = vm.comments[idx].response;
            }

            this.dialog = true;
        },
        clearForm () {
            this.dialog = false;

            // Clear values
            this.isEdition = false
            this.itemID = ''
            this.author_email = ''
            this.comment = ''
            this.createdAtStr = '',
            this.response = ''
        },
        gotoUsers () {
            this.$router.replace('users');
        },
        gotoNews () {
            this.$router.replace('news');
        },
        gotoComments () {
            this.$router.replace('comments');
        },
        gotoShops () {
            this.$router.replace('shops');
        },
        logout () {
            firebase.auth().signOut().then(() => {
                this.$router.replace('login')
            })
        },
        formatDate(d, format, fsep, msep, hsep) {
            if (!d) return "";

            if (!format) format = 'DD/MM/YYYY HH:MM'; 
            if (fsep === undefined) fsep = '/'; 
            if (msep === undefined) msep = ' '; 
            if (hsep === undefined) hsep = ':'; 

            let m = (d.getMonth() + 1);
            if (m < 10) {
                m = "0" + m;
            }

            let mi = d.getMinutes();
            if (mi < 10) {
                mi = "0" + mi;
            }

            if (format == 'YYYYMMDDHHMI') {
                return d.getFullYear() + fsep + m + fsep + d.getDate() + msep + d.getHours() + hsep + mi;
            } else {
                return d.getDate() + fsep + m + fsep + d.getFullYear() + msep + d.getHours() + hsep + mi;
            }
        }
    },
    mounted: function () {
        var vm = this;
        this.$nextTick(function () {
            vm.getComments(true);
        })
    }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: black;
}
input, button {
  margin-bottom: 10px;
}
.formLabel {
  font-size: 12px;
  font-weight: bold;
}
.button_blue {
  background-color: rgb(158, 206, 255);
}
.button_green {
  background-color: rgb(140, 231, 178);
}
.button_red {
  background-color: rgb(255, 154, 154);
}
.logout {
  left: 50%;
  top: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Comments.vue